export default (date: Date): string => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth()).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
